import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#customized-content" }),
  /*#__PURE__*/_createTextVNode(" Customized content ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Content")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Content", -1)
const _hoisted_6 = { class: "percentage-value" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "percentage-label" }, "Progressing", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_progress, {
        percentage: 50,
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_progress, {
        "text-inside": true,
        "stroke-width": 20,
        percentage: 50,
        status: "exception",
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_progress, {
        type: "circle",
        percentage: 100,
        status: "success",
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "success",
            icon: "el-icon-check",
            circle: ""
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_progress, {
        type: "dashboard",
        percentage: 80,
        class: "mb-5"
      }, {
        default: _withCtx(({ percentage }) => [
          _createVNode("span", _hoisted_6, _toDisplayString(percentage) + "%", 1),
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}